export default "__VITE_PUBLIC_ASSET__1ad6b25c__"